import moment from "moment";

export const formatDisplayDate = (dateString) => {
  if (!dateString) {
    return "";
  }

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const parseExportDate = (value) => {
  if (value == null || value === "") {
    return null;
  }

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value;
  }

  const parsed = moment(String(value).trim(), ["DD-MM-YYYY", "YYYY-MM-DD", moment.ISO_8601], true);
  if (!parsed.isValid() || parsed.year() <= 1970) {
    return null;
  }

  return parsed.toDate();
};

export const formatExportDateForCsv = (value, nonDateLabels = []) => {
  if (value == null || value === "" || nonDateLabels.includes(String(value))) {
    return value ?? "";
  }

  const date = parseExportDate(value);
  if (!date) {
    return value;
  }

  return moment(date).format("YYYY-MM-DD");
};
